var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user.tag1 || _vm.user.tag2)?_c('span',{staticClass:"user-tag"},[_vm._v(_vm._s(_vm._f("userTag")(_vm.user)))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }